import type { TrustSet, Transaction } from 'xrpl/dist/npm'
import { XrplCurrency, XrplSubmitResult } from './types'
import { fetchTrustlines } from './balances'

type XrplSignAndSubmit = (tx: Transaction) => Promise<XrplSubmitResult>

export const hasTrustline = async (account: string, currency: XrplCurrency) => {
  if (currency.isNative || currency.currency === 'XRP') {
    return true
  }

  if (!currency.issuer) {
    throw new Error(`Missing issuer for ${currency.symbol}`)
  }

  const lines = await fetchTrustlines(account)
  return Boolean(lines.find((line) => line.currency === currency.currency && line.account === currency.issuer))
}

export const createTrustline = async ({
  account,
  currency,
  limit = '1000000',
  signAndSubmit,
}: {
  account: string
  currency: XrplCurrency
  limit?: string
  signAndSubmit: XrplSignAndSubmit
}) => {
  if (currency.isNative || currency.currency === 'XRP') {
    throw new Error('XRP does not require a trustline')
  }

  if (!currency.issuer) {
    throw new Error(`Missing issuer for ${currency.symbol}`)
  }

  const tx: TrustSet = {
    TransactionType: 'TrustSet',
    Account: account,
    LimitAmount: {
      currency: currency.currency,
      issuer: currency.issuer,
      value: limit,
    },
  }

  return signAndSubmit(tx)
}
